var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 13.312H11.8125V12.187H6.1875V13.312ZM6.1875 10.312H11.8125V9.18701H6.1875V10.312ZM4.73081 16.1245C4.35194 16.1245 4.03125 15.9933 3.76875 15.7308C3.50625 15.4683 3.375 15.1476 3.375 14.7687V3.23032C3.375 2.85145 3.50625 2.53076 3.76875 2.26826C4.03125 2.00576 4.35194 1.87451 4.73081 1.87451H10.6875L14.625 5.81201V14.7687C14.625 15.1476 14.4938 15.4683 14.2313 15.7308C13.9688 15.9933 13.6481 16.1245 13.2692 16.1245H4.73081ZM10.125 6.37451V2.99951H4.73081C4.67306 2.99951 4.62019 3.02357 4.57219 3.0717C4.52406 3.1197 4.5 3.17257 4.5 3.23032V14.7687C4.5 14.8264 4.52406 14.8793 4.57219 14.9273C4.62019 14.9755 4.67306 14.9995 4.73081 14.9995H13.2692C13.3269 14.9995 13.3798 14.9755 13.4278 14.9273C13.4759 14.8793 13.5 14.8264 13.5 14.7687V6.37451H10.125Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes1);
export default __webpack_public_path__ + "static/media/notes1.5fd52806ed23e8fba910d9345fe5e747.svg";
export { ForwardRef as ReactComponent };